import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import styles from './Timeline.module.css';

const DropZone = ({ position, isActive, isDragging, previewSong, playerId, isPlayerActive }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `drop-zone-${playerId}-${position}`,
  });

  // Player 1 is top timeline, Player 2 is bottom timeline
  const alignmentClass = playerId === 1 ? styles.top_timeline : styles.bottom_timeline;

  return (
    <div
      ref={setNodeRef}
      className={`${styles.drop_zone} ${alignmentClass} ${isPlayerActive && (isActive || isOver || isDragging) ? styles.active : ''} ${isPlayerActive && isOver ? styles.hover : ''} ${!isPlayerActive ? styles.disabled : ''}`}>
      {isOver && previewSong && isPlayerActive && (
        <div className={styles.drop_preview}>
          <div className={styles.preview_card}>
            <div className={styles.preview_icon}>🎵</div>
            <div className={styles.preview_text}>Drop here</div>
          </div>
        </div>
      )}
    </div>
  );
};

const TimelineCard = ({ song }) => {
  // Get small album artwork for timeline
  const getSmallAlbumArt = () => {
    if (!song.album_images || song.album_images.length === 0) return null;
    // Use smallest available image for timeline
    const smallImage = song.album_images.find((img) => img.width <= 100);
    return smallImage ? smallImage.url : song.album_images[song.album_images.length - 1].url;
  };

  const albumArt = getSmallAlbumArt();

  return (
    <div
      className={`${styles.timeline_card} ${song.isSeed ? styles.seed_card : ''} ${song.isNew ? styles.new_card : ''} ${song.isCorrectPlacement ? styles.correct_placement : ''}`}>
      <div className={styles.timeline_card_top}>
        {albumArt && (
          <div className={styles.timeline_album_art}>
            <img src={albumArt} alt={`${song.album}`} className={styles.timeline_album_image} />
          </div>
        )}
      </div>

      <div className={styles.timeline_card_info}>
        <div className={styles.timeline_song_title}>{song.title}</div>
        <div className={styles.timeline_song_artist}>{song.artist}</div>
        <div className={styles.timeline_song_album}>{song.album}</div>
        <div className={styles.timeline_song_year}>{song.release_year}</div>

        {song.isSeed && <div className="timeline-badge seed-badge">🌱 Starting Card</div>}
        {song.isCorrectPlacement && (
          <div className="timeline-badge correct-badge">✅ Correct Position</div>
        )}
      </div>
    </div>
  );
};

const Timeline = ({
  timeline,
  isDragging = false,
  previewSong = null,
  playerId,
  isPlayerActive,
  playerName,
}) => {
  return (
    <section className={`${styles.timeline_section} ${isPlayerActive ? styles.active_player : styles.inactive_player}`}>
      <h2>{playerName}'s Timeline</h2>
      <div
        className={`${styles.timeline} ${isDragging && isPlayerActive ? styles.drag_over : ''} ${!isPlayerActive ? styles.disabled : ''}`}>
        {timeline.length === 0 ? (
          <>
            <div className={styles.timeline_placeholder}>
              <span>Empty Timeline - Start the game to get your first card!</span>
            </div>
            <DropZone
              position={0}
              isDragging={isDragging}
              previewSong={previewSong}
              playerId={playerId}
              isPlayerActive={isPlayerActive}
            />
          </>
        ) : (
          <>
            {timeline.map((song, index) => (
              <React.Fragment key={song.id}>
                <DropZone
                  position={index}
                  isDragging={isDragging}
                  previewSong={previewSong}
                  playerId={playerId}
                  isPlayerActive={isPlayerActive}
                />
                <TimelineCard song={song} />
              </React.Fragment>
            ))}
            <DropZone
              position={timeline.length}
              isDragging={isDragging}
              previewSong={previewSong}
              playerId={playerId}
              isPlayerActive={isPlayerActive}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default Timeline;